import { useEffect } from "react";

import { type Message } from "@internal/plugin-askjack-common";

/** Scrolls `endRef` into view whenever `messages` changes. */
export const useScrollToBottom = (
    messages: Message[],
    endRef: React.RefObject<HTMLDivElement>
): void => {
    useEffect(() => {
        endRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, endRef]);
};
